var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "profile-nav section-border--top section-border--right section-border--bottom",
      class: { mobile: _vm.isMobile },
    },
    [
      _c(
        "ul",
        _vm._l(_vm.profileMenu.submenu, function (item, index) {
          return _c(
            "li",
            { key: index },
            [
              _c("nuxt-link", { attrs: { to: item.link } }, [
                _vm._v("\n        " + _vm._s(item.title) + "\n      "),
              ]),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }